<template>
  <transition name="fade">
    <div class="app-loader" v-if="isVisible">
      <div class="app-loader__overlay"></div>
      <div class="app-loader__progress-bar"></div>
    </div>
  </transition>
</template>
<script src="./app-loader.js"></script>
<style src="./app-loader.scss" lang="scss"></style>
